import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Llevaba meses orando por paz en mi casa y en mis finanzas, pero por dentro seguía igual de tensa. Con este programa aprendí a empezar el día diferente: primero me calmo, luego oro, luego actúo. Algo tan simple cambió mi tono en casa y mi manera de ver el dinero. La Libreta de Gratitud y Provisión me ayudó a enfocarme en lo que Dios ya estaba haciendo, no solo en lo que faltaba.',
    name: 'Rosa M.',
    description: 'Mamá de 3 hijos',
    location: 'Bogotá, Colombia'
  }, {
    quote: 'Tengo 61 años y pensé que ya era tarde para cambiar mis hábitos espirituales. Pero 10–15 minutos al día es algo que sí podía hacer. Lo que más me llegó fue entender que mi oración puede nacer desde la paz y no desde el susto. Dios no cambió: cambié yo por dentro. Hoy camino con más confianza y menos peso en el pecho.',
    name: 'Jorge A.',
    description: 'Jubilado',
    location: 'Guadalajara, México'
  }, {
    quote: 'Soy creyente desde joven, pero admito que oraba más desde el miedo que desde la fe. Este método me enseñó a detenerme, escribir una promesa y dar un paso concreto, sin ansiedad. Las meditaciones de cierre de semana fueron lo que más me ayudó: por primera vez sentí que mi interior y mis decisiones iban en la misma dirección.',
    name: 'Carlos V.',
    description: 'Empresario',
    location: 'Lima, Perú'
  }, {
    quote: 'Como emprendedora, la ansiedad por el dinero era constante. Oraba, pero seguía tomando decisiones desde el pánico. Con R.E.V.E.L.A. aprendí a ordenar mi interior antes de actuar. No es magia: es fe con hábito. La libreta de gratitud me ayudó a ver la provisión que ya tenía y a dar pasos con más claridad. Fue el programa más práctico y espiritual que he encontrado.',
    name: 'Valeria R.',
    description: 'Emprendedora',
    location: 'Madrid, España'
  }];
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-360">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-361">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-362">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-12 text-center" data-id="element-363">
            Lo que están viviendo quienes ya comenzaron
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-364">
            {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-cream rounded-lg p-8 shadow-md" data-id="element-365">
                <div className="flex gap-1 mb-4" data-id="element-366">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-367" />)}
                </div>
                <p className="text-dark/80 italic mb-6 leading-relaxed" data-id="element-368">
                  "{testimonial.quote}"
                </p>
                <div data-id="element-369">
                  <p className="font-bold text-navy" data-id="element-370">{testimonial.name}</p>
                  <p className="text-sm text-muted" data-id="element-371">
                    {testimonial.description} — {testimonial.location}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}